import PropTypes from 'prop-types'
import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap"
import { Link } from "react-router-dom"
import Util from "./Common/Util"

import moment from 'moment';

// import images
import client from "../../assets/images/client.png";
import transactionAmount from "../../assets/images/transactionAmount.png";
import transactionPrice from "../../assets/images/transactionPrice.png";
import tradeHistory from "../../assets/images/거래내역.jpg";
import news from "../../assets/images/news.jpg";

// Charts
import LineAreaChart from "../AllCharts/apex/lineareachart";
import ChartistGraph from 'react-chartist';

import "chartist/dist/scss/chartist.scss";

import { useSelector } from 'react-redux';

import store from "store"
import { setRefresh } from 'store/auth/data/actions';
import { SET_REFRESH } from "store/auth/data/actionTypes"

import { driverResponse, driverCompanyResponse, disposeDataResponse, listDelete, disposeWearing, uncollectUpload, postWasteData, postWasteCollection } from 'crud/auth.crud';
import { useEffect } from 'react';

import loading from "../../assets/images/loading.gif";

const style = { backgroundColor: "#ffffff", padding: "0.3rem", cursor: "pointer", width: 240 };

const hoverStyle = { backgroundColor: "#48C3B1", color: "#ffffff", width: 240 };

const Dashboard = props => {
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()

  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [modalShow4, setModalShow4] = useState(false);
  const [modalShow5, setModalShow5] = useState(false);
  const [modalShow6, setModalShow6] = useState(false);
  const [reset, setReset] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [disposeList, setDisposeList] = useState([]);
  const [page, setPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [date, setDate] = useState(moment(newDate).format('YYYY.MM.DD'));
  const [startDate, setStartDate] = useState(moment(nextDate.setDate(nextDate.getDate())).format('YYYY-MM-DD') + ' 00:00:00');
  const [endDate, setEndDate] = useState(moment(nextDate.setDate(nextDate.getDate() + 1)).format('YYYY-MM-DD') + ' 00:00:00');
  const [companyCount, setCompanyCount] = useState(0);
  const [collectSum, setCollectSum] = useState(0);
  const [disposeSum, setDisposeSum] = useState(0);
  const [user, setUser] = useState(selector.auth?.user);
  const [company, setCompany] = useState(undefined);
  const [companyList, setCompanyList] = useState([]);
  const [reason, setReason] = useState('');
  const [driverCompany, setDriverCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group);
  const [treatmentList, setTreatmentList] = useState([]);
  const [treatment, setTreatment] = useState(undefined);
  const [emitter, setEmitter] = useState(undefined);
  const [dispose, setDispose] = useState('');
  const [isHover, setIsHover] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [imgArr, setImgArr] = useState([]);
  const [wasteCollect, setWasteCollect] = useState('');

  const reasonValue = [
    { 'key': 'cannotAccess', 'text': '도로 진입불가' },
    { 'key': 'locked', 'text': '사업장문잠김' },
    { 'key': 'cannotConfirm', 'text': '수거통 위치 확인불가' },
  ]

  // 지금 이 시간 웨이스트버스는? 가져오는 용
  // const getDashboardData = async () => {
  //   const response = await dashboardResponse();    
  //   if(response.data?.result === 'success'){
  //     const item = response.data?.data
  //     setCompanyCount(item.company_count);
  //     setCollectSum(item.sum_collect);
  //     setCollectMoneySum(item.sum_collect_money);
  //   }
  // }

  // driver 데이터 가져오는 용
  const getDataList = async () => {
    try {
      const params = {
        member: user.id,
        driver_company: user.member_group?.[0]?.company_group?.id,
        start_date: startDate,
        end_date: endDate,
      }
      const response = await driverResponse(params);
      if (response.data?.result === 'success') {
        const dataList = response?.data?.data;
        const count = dataList.length;
        let collectSum = 0;
        for (let i = 0; i < count; i++) {
          collectSum += dataList[i].qty
        }
        setDataList(dataList)
        setCompanyCount(count)
        setCollectSum(collectSum)
        getDisposeData()
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getDisposeData = async () => {
    try {
      const params = {
        member: user.id,
        company: driverCompany.id,
        start_date: startDate,
        end_date: endDate,
      }
      const response = await disposeDataResponse(params);
      if (response.data?.result === 'success') {
        const disposeSum = response?.data?.data?.qty_sum || 0;
        setDisposeSum(disposeSum)
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCompanyList = async () => {
    const params = `?id=${driverCompany.id}&company_type=emitter`
    const rs = await driverCompanyResponse(params)
    const rsData = rs.data?.data || [];
    let tmp = []
    for (let i = 0; i < rsData.length; i++) {
      for (let j = 0; j < rsData[i].length; j++) {
        if (tmp.filter(itm => itm.company !== rsData[i][j].company)) {
          tmp.push(rsData[i][j].contract_company_group_data)
        }
      }
    }
    setCompanyList(tmp)
  }

  const getTreatmentList = async () => {
    const params = `?id=${driverCompany.id}&company_type=treatment`
    const rs = await driverCompanyResponse(params)
    const rsData = rs.data?.data || [];
    let tmp = []
    for (let i = 0; i < rsData.length; i++) {
      for (let j = 0; j < rsData[i].length; j++) {
        if (tmp.filter(itm => itm.company !== rsData[i][j].company)) {
          tmp.push(rsData[i][j])
        }
      }
    }
    setTreatmentList(tmp)
  }

  useEffect(() => {
    getDataList();
    getCompanyList();
    getTreatmentList();
    const unsubscribe = store.subscribe(() => {
      if (store.getState().data?.refresh === 'main') {
        getDataList();
        store.dispatch(setRefresh(''));
      }
    });
  }, [])

  const selectCompany = (item) => {
    setModalShow(false)
    setCompany(item)
    setModalShow2(true)
  }

  const selectTreatment = (item) => {
    setModalShow3(false)
    setTreatment(item)
    setModalShow4(true)
  }

  const selectEmitter = (item) => {
    setModalShow5(false)
    setEmitter(item)
    setModalShow6(true)
  }

  const deleteUnCollect = async (id) => {
    if (confirm("해당 미수거 내역을 삭제하시겠습니까?")) {
      await listDelete(id)
      getDataList()
    }
  }

  const saveDisposeAndWearing = async () => {
    if (dispose === '' || treatment === undefined) {
      return
    }
    const pricePerKg = treatment.contract_group_data.price_per_kg || 50;
    const params = {
      company_id: driverCompany.id,
      member_id: user.id,
      qty: dispose,
      price: dispose * pricePerKg,
      treatment_id: treatment.company
    }

    const response = await disposeWearing(params);
    setDispose('')
    setTreatment(undefined)
    setModalShow4(false)
    if (response.data?.result === 'success') {
      store.dispatch(setRefresh('dispose'));
      alert("정상적으로 인계되었습니다. 인계 내역에서 확인해주세요.")
      getDisposeData();
    }
  }

  const saveUnCollect = async () => {
    if (reason === '' || company === undefined) {
      return
    }

    const params = {
      company_id: company.id,
      memo: reason,
      driver_company_id: driverCompany.id,
      member_id: user.id,
      qty: 0,
      state: 'N',
    }

    const response = await uncollectUpload(params);
    setReason('')
    setCompany(undefined)
    setModalShow2(false)
    if (response.data?.result === 'success') {
      getDataList()
    }
  }

  const checkPosition = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function(position) {
          saveWasteCollect(position)
        },
        function(error) {
          console.error("오류: " + error.message);
        }
      );
    } else {
      console.error("이 브라우저는 위치 정보를 지원하지 않습니다.");
    }
  }

  const saveWasteCollect = async (position) => {
    setIsLoading(true)
    try {
      const fd = new FormData();

      const newFile = new File([imgArr[0]], `${encodeURI(imgArr[0].name)}`, {type: imgArr[0].type})
      fd.append('file_0', newFile);

      const wasteCollectData = {
        wasteverse_bar: 'A1',
        rf_id: 1,
        company: emitter?.id,
        memo: '',
        driver_company: driverCompany.id,
        member: user.id,
        qty: wasteCollect,
        state: 'Y',
      }
      fd.append('waste_collect_data', JSON.stringify(wasteCollectData))

      const tmsData = {
        company: driverCompany.id,
        member: user.id, start_date: startDate,
        x: position.coords?.longitude,
        y: position.coords?.latitude,
        rf_id: 1,
        wasteverse_bar: 'A1',
      }
      fd.append('tms_data', JSON.stringify(tmsData))

      const response = await postWasteData(fd);
      if (response.data?.result === 'success') {
        getDataList()
      }
      setModalShow6(false);
      setIsLoading(false);
      setWasteCollect('');
      setImgArr([]);

    } catch (e) {
      setModalShow6(false);
      setIsLoading(false);
      console.log(e);
    }
  }

  const handleFileChange = (event) => {
    const files = event.target.files;
    const newPreviewImages = [];
    const readers = [];

    for (let i = 0; i < files.length; i++) {
      readers[i] = new FileReader();

      readers[i].onload = (event) => {
        newPreviewImages[i] = event.target.result;
        setPreviewImages([...newPreviewImages]);
      };

      readers[i].readAsDataURL(files[i]);
    }
  };

  const deleteImage = (index) => {
    let newImgArr = [...imgArr]
    newImgArr.splice(index, 1)
    setImgArr(newImgArr)
  }

  return (
    // <React.Fragment>
    //   <div className="page-content">
    //     <MetaTags>
    //       <title>홈 | 웨이스트버스</title>
    //     </MetaTags>
    //     <Container fluid>
    //       <div className="page-title-box">
    //         <Row className="align-items-center">
    //           <Col md={8}>
    //             <h6 className="page-title">관리 홈</h6>
    //             <ol className="breadcrumb m-0">
    //               <li className="breadcrumb-item active">'국내최초' 음식물류 폐기물 스마트 수거 플랫폼</li>
    //             </ol>
    //           </Col>

    //         </Row>
    //       </div>
    <>
      <div style={{ display: 'flex' }}>
        <div style={{width: '20%'}}>
          <div style={{ display: 'flex', height: 35 }}>
            <button
              className="btn btn-primary w-md waves-effect waves-light"
              type="submit"
              onClick={() => {
                modalShow5 ? setModalShow5(false) : setModalShow5(true),
                setModalShow(false),
                setModalShow3(false)
              }}
            // style={{marginBottom: 36}}
            >
              웨버바 측정
            </button>
          </div>
          <div style={{ position: 'absolute', zIndex: 1 }}>
            {modalShow5 &&
              companyList && companyList.map((item, index) => {
                return (
                  // <div key={index} onClick={()=>{
                  //   selectTreatment(item)
                  // }}>
                  //   <p>{item.contract_company_group_data.name}</p>
                  // </div>
                  <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                    onMouseOver={() => {
                      setIsHover(item.id)
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      selectEmitter(item)
                    }}>{item.name}
                  </div>
                )
              })
            }
          </div>
        </div>
        <div style={{width: '80%'}}>
          <div style={{ display: 'flex', height: 35 }}>
            <button
              className="btn btn-primary w-md waves-effect waves-light"
              type="submit"
              onClick={() => {
                modalShow3 ? setModalShow3(false) : setModalShow3(true),
                modalShow4 ? setModalShow4(false) : null,
                setModalShow(false),
                setModalShow5(false)
              }}
            // style={{marginBottom: 36}}
            >
              인계량 등록하기
            </button>
            {modalShow4 &&
              <div style={{ display: 'flex' }}>
                <input style={{ width: 180, marginLeft: 24 }} className='is-untouched is-pristine av-invalid form-control'
                  onChange={(e) => {
                    setDispose(e.target.value)
                  }} placeholder='인계량을 입력해주세요.'></input>
                <p style={{ lineHeight: '35px' }}>&nbsp;kg</p>
                <button style={{ width: 90, marginLeft: 6 }} className='btn btn-primary waves-effect waves-light' onClick={() => {
                  saveDisposeAndWearing()
                }}>등록하기</button>
              </div>
            }
          </div>
          <div style={{ position: 'absolute' }}>
            {modalShow3 &&
              treatmentList && treatmentList.map((item, index) => {
                return (
                  // <div key={index} onClick={()=>{
                  //   selectTreatment(item)
                  // }}>
                  //   <p>{item.contract_company_group_data.name}</p>
                  // </div>
                  <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                    onMouseOver={() => {
                      setIsHover(item.id)
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      selectTreatment(item)
                    }}>{item.contract_company_group_data.name}
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
      <Row>
        <Col xl={9}>
          <Card>
          </Card>
        </Col>

        <Container fluid>
          <div className="page-title-box" style={{ paddingTop: 0 }}>
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">지금 이 시간 웨이스트버스는?</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active"></li>
                </ol>
              </Col>
            </Row>
          </div>
        </Container>

        <Col xl={1} md={6} style={{ width: "15%" }}>
          <Card className="mini-stat text-white" style={{ backgroundColor: '#C9CACA' }}>
            <CardBody>
              <div className="mb-4">
                <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                  이 시간 웨버는?
                </h5>
                <h4 className="fw-medium font-size-22">
                  수거·처리{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={2} md={6} style={{ width: "20%" }}>
          <Card className="mini-stat bg-primary text-white">
            <CardBody>
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src={client} alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                  방문한 거래처
                </h5>
                <h4 className="fw-medium font-size-22">
                  {Util.setPrice(companyCount)}개{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={2} md={6} style={{ width: "20%" }}>
          <Card className="mini-stat bg-primary text-white">
            <CardBody>
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src={transactionAmount} alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                  총 수거량
                </h5>
                <h4 className="fw-medium font-size-22">
                  {Util.setPrice(collectSum)}L{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={2} md={6} style={{ width: "20%" }}>
          <Card className="mini-stat bg-primary text-white">
            <CardBody>
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src={transactionPrice} alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                  총 인계량
                </h5>
                <h4 className="fw-medium font-size-22">
                  {Util.setPrice(disposeSum)}kg{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <div style={{ display: 'flex', height: 35, marginTop: 12 }}>
        <button
          className="btn btn-primary w-md waves-effect waves-light"
          type="submit"
          onClick={() => {
            modalShow ? setModalShow(false) : setModalShow(true),
            modalShow2 ? setModalShow2(false) : null,
            setModalShow3(false),
            setModalShow5(false)
          }}
        >
          미수거 등록
        </button>
        {modalShow2 &&
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {reasonValue && reasonValue.map((item, index) => {
              return (
                <div key={index} style={{ margin: "8px 0 0 6px" }}>
                  <input className="is-untouched is-pristine av-valid form-check-input" type='radio' checked={reason == item.key} id={item.key} value={item.key} onClick={(e) => {
                    reason == item.key ? setReason('') : setReason(item.key)
                  }} />
                  <label style={{ marginLeft: 3 }} className="form-check-label" htmlFor={item.key} >{item.text}</label>
                </div>
              )
            })}
            <button style={{ width: 90, marginLeft: 6 }} className='btn btn-primary waves-effect waves-light' onClick={() => {
              saveUnCollect()
            }}>등록하기</button>
          </div>
        }
      </div>

      <div style={{ position: 'absolute' }}>
        {modalShow &&
          companyList && companyList.map((item, index) => {
            return (
              <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                onMouseOver={() => {
                  setIsHover(item.id)
                }}
                onMouseLeave={() => {
                  setIsHover(false)
                }}
                onClick={() => {
                  selectCompany(item)
                }}>{item.name}
              </div>
            )
          })
        }
      </div>

      <Card style={{ marginTop: 36 }}>
        <CardBody>
          <h4 className="card-title mb-4">수거 업체 목록</h4>
          <div className="table-responsive">
            <table className="table table-hover table-centered table-nowrap mb-0">
              <thead>
                <tr>
                  <th scope="col" style={{ display: 'flex' }}><p style={{ fontWeight: 600 }}>ID</p></th>
                  <th scope="col" style={{ fontWeight: 600 }}>업체명</th>
                  <th scope="col" style={{ fontWeight: 600 }}>등록시간</th>
                  <th scope="col" style={{ fontWeight: 600 }}>수거 여부(수거량)</th>
                  <th scope="col" style={{ fontWeight: 600 }}>미수거 사유</th>
                  <th scope="col" style={{ fontWeight: 600 }}>삭제</th>
                </tr>
              </thead>
              <tbody>

                {
                  dataList && dataList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <th scope="row">{item.id}</th>
                        <td style={{ cursor: "pointer" }}>{item.company.name}</td>
                        <td>{moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
                        <td style={{ color: item.state === 'Y' ? 'blue' : 'red', fontWeight: 'bold' }}>{item.state === 'Y' ? `수거완료 (${item.qty}L)` : '미수거'}</td>
                        <td>{reasonValue.filter(itm => itm.key === item.memo)?.[0]?.text}</td>
                        <td><i style={{ marginLeft: 8, display: item.state === 'Y' && 'none', cursor: 'pointer' }} className="fa fa-solid fa-trash" onClick={() => {
                          deleteUnCollect(item.id)
                        }} /></td>
                      </tr>
                    )
                  })
                }

              </tbody>
            </table>
          </div>
        </CardBody>

      </Card>

      {/* {companyList && companyList.map((item, index) => {
            return (
              <div key={index}>
                <p>
                  {item.name}
                </p>
              </div>
            )
          })} */}

      {/* <Row>
            {newsList && newsList.map((item, index) => { return (
              <Col xl={4} md={6} key={index}>
                <Card className="directory-card">
                  <CardBody>
                    <div className="d-flex">
                      <img
                        src={item.image_url}
                        alt="사진"
                        className="img-fluid img-thumbnail avatar-lg"
                        style={{width: 6.5 + 'rem', height: 5.5 + 'rem'}}
                      />
                      <div className="flex-1 ms-3">
                        <h5 className="text-primary font-size-18 mt-0 mb-1">
                        {item.subject}
                        </h5>
                        <p className="font-size-12 mb-2">{item.created_at.substr(11, 8)}</p>
                        <p className="mb-0">{item.created_at.substr(0, 10)}</p>
                      </div>
                    </div>
                    <hr />
                    <p className="mb-0">
                      <b>{item.content}</b>{" "}
                      <a href={item.link} target="_blank" className="text-primary">
                        {" "}
                        더 보기
                      </a>
                    </p>
                  </CardBody>
                </Card>
              </Col>
            )})
            }
          </Row> */}
      {modalShow6 && <div style={{
        position: "fixed",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div style={{ width: 480, height: 492, backgroundColor: "#fff", zIndex: 1000, padding: 36 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 20, color: 'black', fontWeight: 'bold' }}>웨버바 수거량 등록</p>
            <p style={{ cursor: "pointer", fontSize: 20 }} onClick={() => {
              setModalShow6(false)
            }}>X</p>
          </div>
          <div style={{ padding: 12 }}>
            <div style={{ marginBottom: 50 }}>
              <div style={{ display: "flex" }}>
                <p style={{ fontSize: 16, width: 110, lineHeight: '35px' }}>이미지 등록</p>
                <label className="btn btn-primary waves-effect waves-light" htmlFor="getFile" style={{ height: 36, marginLeft: 6 }}>파일 선택</label>
                <input style={{ display: "none" }} type="file" id="getFile" accept="image/*" onChange={(e) => {
                  handleFileChange(e)
                  setImgArr(e.target.files)
                }} />
              </div>
              <div style={{ width: 120 }}>
                {previewImages.length > 0 ? previewImages.map((image, index) => (
                  <>
                    <div key={index} style={{ width: "fit-content", width: 120, position: "relative", marginBottom: 24 }}>
                      <img style={{ width: 120, fontSize: 16, lineHeight: '35px', padding: 3, border: "1.5px solid #48C3B1" }} src={image} />
                      <p style={{ position: "absolute", top: 6, right: 12, cursor: "pointer" }} onClick={() => {
                        deleteImage(index)
                        setPreviewImages(previewImages.filter(v => v !== image))
                      }}>X</p>
                    </div>
                  </>
                )) : <></>
                }
              </div>
            </div>
            <div style={{ display: "flex", height: 35 }}>
              <p style={{ fontSize: 16, width: 110, lineHeight: '35px' }}>수거량</p>
              <input style={{ width: 180 }} className='is-untouched is-pristine av-invalid form-control'
                onChange={(e) => {
                  setWasteCollect(e.target.value)
                }} placeholder='인계량을 입력해주세요.'></input>
              <p style={{ lineHeight: '35px' }}>&nbsp;L</p>
            </div>
            <button style={{ margin: "60px auto 0", display: "block" }} className="btn btn-primary w-md waves-effect waves-light" type="submit" onClick={() => {
              checkPosition()
            }}>등록하기
            </button>
          </div>
        </div>
      </div>}
      {isLoading && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'5%'}></img>
      </div>}
    </>
    //     </Container>
    //   </div>

    // </React.Fragment>
  )
}

export default Dashboard
